import { ActionButton, ActionButtonType, Drawer } from "@octopusdeploy/design-system-components";
import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import React, { useState } from "react";
import { Timeline } from "./Timeline/Timeline";
interface DeploymentTimelineDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    deploymentName: string;
    environmentId: string;
    projectId: string;
    tentantId?: string;
    spaceId: string;
}
const pageSize = 30;
export const DeploymentTimelineDrawer = (props: DeploymentTimelineDrawerProps) => {
    const [currentPage, setCurrentPage] = useState(0);
    const { result } = useInlineStatusQuery((repository) => {
        return repository.Deployments.getDeploymentTimeline(props.projectId, props.environmentId, props.tentantId, 0, (currentPage + 1) * pageSize);
    }, [props.projectId, props.environmentId, props.tentantId, currentPage], "Timeline Data Query", {
        refetchIntervalInMs: props.isOpen ? 3000 : undefined, //No need to refresh if the Drawer is not showing.
    });
    const loadMore = () => {
        setCurrentPage((prev) => prev + 1);
    };
    const items = result?.TimelineItems.Items ?? [];
    const hasMore = (result?.TimelineItems?.TotalResults ?? 0) > (result?.TimelineItems?.Items?.length ?? 0);
    return (<Drawer isOpen={props.isOpen} onClose={() => {
            return;
        }} title="Deployment Timeline" subtitle={`${props.deploymentName} deployments to ${result?.EnvironmentName}`} variant="customActions" layout="basic" customActions={[<ActionButton onClick={props.onClose} type={ActionButtonType.Secondary} label="Close"/>]} width="narrow">
            <Timeline timelineData={items} loadMore={loadMore} hasMore={hasMore}/>
        </Drawer>);
};
